export const SupportedLanguage = {
  EN: "en",
  SV: "sv",
  FI: "fi",
} as const;

export type SupportedLanguage =
  (typeof SupportedLanguage)[keyof typeof SupportedLanguage];
